import React, { useMemo } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { Colors } from "@constants";
import { Title18 } from "@stylesheets";
import { ProfileTabs } from "@modules/profile";
import { useDevices } from "@hooks";
import { Forward } from "@assets";

interface IProps {
  tabName: ProfileTabs;
  title: string;
  icon: React.ReactNode;
  isSelected: boolean;
  onSelectedTab: (tab: ProfileTabs) => void;
  forwardTestID?: string;
  showForward?: boolean;
  isDisabled?: boolean;
  collapsed?: boolean;
}

export const ProfileMenuTab: React.FC<IProps> = React.memo(
  ({
    tabName,
    title,
    forwardTestID,
    icon,
    isSelected,
    onSelectedTab,
    showForward,
    isDisabled = false,
    collapsed
  }) => {
    const [isMobile] = useDevices();
    const onSelect = () => {
      onSelectedTab(tabName);
    };

    const styles = useMemo(() => _styles(isMobile, isDisabled), [isMobile, isDisabled]);

    return (
      <TouchableOpacity
        testID={forwardTestID}
        style={styles.container}
        disabled={isDisabled}
        onPress={onSelect}
      >
        <View style={styles.subContainer}>
          {icon}
          {!collapsed && <Title18 style={[styles.title, isSelected && styles.selectedStyle]}>
            {title}
          </Title18>}
        </View>

        {isMobile && showForward && <Forward />}
      </TouchableOpacity>
    );
  }
);

const _styles = (isMobile: boolean, isDisabled: boolean) =>
  StyleSheet.create({
    title: {
      color: Colors.black,
      marginLeft: 10,
    },
    container: {
      justifyContent: isMobile ? "space-between" : "center",
      alignItems: "center",
      flexDirection: "row",
      width: isMobile ? "90vw" : "auto",
      opacity: isDisabled ? 0.5 : 1,
    },
    subContainer: {
      flexDirection: "row",
    },
    selectedStyle: {
      fontWeight: isMobile ? "normal" : "bold",
    },
  });
